<template>
  <div class="main">

    <!-- 配送单详情待付款时弹出 -->
    <Dialog ref="dia4" :config="config" :lock-scroll="false">
      <div>
        <p>
          Привіт
          {{
            $store.state.userInfo.user_name
          }},{{ $fanyi('您即将查看配送单的详细内容，您可以在当前界面查看国际运费的报价信息。') }}
        </p>
        <p>
          {{
            $fanyi('确认无误后，您可以点击”去付款“进行支付。确认收款后，我们将安排物流发货。物流更进详情将通过邮件发给您。如果您需要调整产品包装等，请将详细信息发送给我们。根据您的修改要求进行调整后，我们将提供新的报价。')
          }}
        </p>
        <p>
          {{ $fanyi('（因为客户直接调整将导致产品的实际包装数据异常，我们限制了客户直接调整交付订单的功能，请谅解。）') }}
        </p>
      </div>

    </Dialog>
  </div>
</template>
<script>
import Dialog from '../../../../../../../components/public/Dialog.vue'

export default {
  data() {
    return {
      config: {
        top: '30vh',
        width: '800px',
        title: this.$fanyi('注意'),
        btnTxt: [this.$fanyi("已了解")],
      },
    }
  },
  components: { Dialog },
  computed: {
    status_name() {
      return this.$parent.datas.result.status_name
    },
  },
  mounted() {
  },
  methods: {
    openOrderDia() {

      if (this.status_name == '等待付款') {
        this.$refs.dia4.open('', (cancel) => { cancel() }, () => { })
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../../../css/mixin.scss';

/deep/.el-dialog__footer .el-button:last-child {
  border: 0px !important;
}



p {
  font-size: 16px;
  text-indent: 1cm;
  margin-bottom: 10px;
  line-height: 24px;
}
</style>
